import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

const Home = ({ user }) => {
  return (
    <div>
      {
        user.login.role !== 'ALGO' ? 
      <div className="home-link-dev-row">
        <div className="home-link-dev">
          <Link to='/workout' className="home-link">
          <p className="home-link-text" style={{textAlign: 'center'}}> Workouts </p>
          </Link>
        </div>
        <div className="home-link-dev">
          <Link to='/workoutVideos' className="home-link">
          <p className="home-link-text" style={{textAlign: 'center'}}> Workouts Videos </p>
          </Link>
        </div>
        <div className="home-link-dev">
          <Link to='/exercise' className="home-link">
          <p className="home-link-text" style={{textAlign: 'center'}}> Exercises</p>
          </Link>
        </div>
        <div className="home-link-dev">
          <Link to='/feedback' className="home-link">
          <p className="home-link-text" style={{textAlign: 'center'}}> Specific Feedbacks </p>
          </Link>
        </div>
      </div>
     : null 
      }
     
      {
        user.login.role !== 'EDIT' && user.login.role !== 'ALGO' ? 
        <div>
          <div className="home-link-dev-row">
            <div className="home-link-dev">
              <Link to='/motivationFeedback'className="home-link" >
              <p className="home-link-text" style={{textAlign: 'center'}}> Motivation Feedbacks</p>
              </Link>
            </div>
            <div className="home-link-dev">
              <Link to='/trainer' className="home-link">
              <p className="home-link-text" style={{textAlign: 'center'}}> Trainer</p>
              </Link>
            </div>
            <div className="home-link-dev">
              <Link to='/users' className="home-link">
              <p className="home-link-text" style={{textAlign: 'center'}}> Users </p>
              </Link>
            </div>
            <div className="home-link-dev">
              <Link to='/numbers'  className="home-link">
              <p className="home-link-text"  style={{textAlign: 'center'}}> Numbers </p>
              </Link>
            </div>
          </div>
          <div className="home-link-dev-row">
            <div className="home-link-dev">
              <Link to='/updateUser' className="home-link">
              <p className="home-link-text" style={{textAlign: 'center'}}> Free User </p>
              </Link>
            </div>
            <div className="home-link-dev">
              <Link to='/skills' className="home-link">
              <p className="home-link-text" style={{textAlign: 'center'}}> Skills </p>
              </Link>
            </div>
            <div className="home-link-dev">
              <Link to='/dataset' className="home-link">
              <p className="home-link-text" style={{textAlign: 'center'}}> Dataset Samples </p>
              </Link>
            </div>
            <div className="home-link-dev">
              <Link to='/plan' className="home-link">
              <p className="home-link-text" style={{textAlign: 'center'}}> Plan </p>
              </Link>
            </div>
          </div>
        </div>
        : <div className="home-link-dev">
            <Link to='/dataset' className="home-link">
            <p className="home-link-text" style={{textAlign: 'center'}}> Dataset Samples </p>
            </Link>
          </div>
      }
    </div>
  );
}

function mapStateToProps (state) {
  return {
   user: state.login
  }
}
export default connect(mapStateToProps)(Home);